/**
 * Centralized untyped Supabase client surface.
 * Replaces copy-pasted supabaseAny declarations.
 * Prefer the typed `supabase` export from ./client.ts for tables/RPCs in generated types.
 */
import { supabase } from './client';

export const supabaseUntyped = supabase as unknown as {
  from: typeof supabase.from;
  rpc: (
    fn: string,
    args?: Record<string, unknown>
  ) => Promise<{ data: unknown; error: { message?: string; code?: string } | null }>;
  auth: typeof supabase.auth;
};
